export const VEG_WEEK_DAYS = [
  {
    title: 'Day 1 — South Indian start',
    meals: [
      'Breakfast: 2–3 egg veggie omelette + 2 idlis (or oatmeal with banana and walnuts)',
      'Snack: Apple + 2 tbsp peanut butter',
      'Lunch: Sambar + 1 cup rice + cucumber salad + ½ cup Greek yogurt',
      'Afternoon snack: Banana + handful of dates',
      'Dinner: Palak paneer (light oil) + 2 phulkas + roasted cauliflower',
      'Evening (optional): Whey or 2 boiled eggs + orange',
    ],
  },
  {
    title: 'Day 2 — North Indian bowl',
    meals: [
      'Breakfast: Paneer bhurji (100 g paneer) + 2 multigrain toasts + berries',
      'Snack: Carrots + hummus',
      'Lunch: Chana masala + brown rice + kachumber + buttermilk',
      'Afternoon snack: 1 cup low-fat yogurt + granola',
      'Dinner: Tofu stir-fry (soy-ginger) + quinoa + steamed broccoli',
      'Evening: Warm milk with turmeric (optional)',
    ],
  },
  {
    title: 'Day 3 — Balanced energy day',
    meals: [
      'Breakfast: Overnight oats (oats, milk, chia, mango or berries) + 2 boiled eggs',
      'Snack: Unsalted trail mix',
      'Lunch: Rajma + jeera rice + mixed veg sabzi',
      'Afternoon snack: Peanut butter whole-grain sandwich',
      'Dinner: Moong dal khichdi + light kadhi + sautéed green beans',
      'Evening: Chocolate milk or yogurt + banana',
    ],
  },
  {
    title: 'Day 4 — Mediterranean-Indian mix',
    meals: [
      'Breakfast: Greek yogurt parfait (seeds, honey, fruit) + 1 boiled egg',
      'Snack: Cottage cheese + pineapple',
      'Lunch: Whole-wheat wrap with hummus, grilled paneer, lettuce, tomato',
      'Afternoon snack: Rice cakes + almond butter',
      'Dinner: Dal tadka + 2 rotis + bhindi or baingan sabzi',
      'Evening: Herbal tea + almonds',
    ],
  },
  {
    title: 'Day 5 — Protein-forward day',
    meals: [
      'Breakfast: Masala scrambled eggs (3 eggs) + 1 paratha or 2 rotis + mint chutney',
      'Snack: Orange + paneer cubes',
      'Lunch: Lentil soup + quinoa salad (chickpeas, cucumber, tomato, lemon)',
      'Afternoon snack: Smoothie—banana, spinach, milk, optional whey',
      'Dinner: Vegetable biryani (moderate oil) + raita + side salad',
      'Evening: Eggs or whey + small portion of rice if hungry',
    ],
  },
  {
    title: 'Day 6 — Light & fresh',
    meals: [
      'Breakfast: Vegetable upma or poha + peanuts + side yogurt',
      'Snack: Steamed edamame',
      'Lunch: Toor dal + millet or rice + cabbage poriyal',
      'Snack: Air-popped popcorn + fruit',
      'Dinner: Grilled paneer or tofu tikka + salad + small rice portion',
      'Evening: Unsweetened lassi or kefir',
    ],
  },
  {
    title: 'Day 7 — Prep-friendly reset',
    meals: [
      'Breakfast: Avocado toast + 2 poached eggs + tomatoes',
      'Snack: Protein smoothie (milk, banana, peanut butter, spinach)',
      'Lunch: Buddha bowl—brown rice, sweet potato, chickpeas, tahini-lemon dressing',
      'Afternoon snack: Dates + walnuts',
      'Dinner: Mix veg curry + 2 rotis + dal from batch prep',
      'Treat (optional): One small portion of kheer or dark chocolate—planned, not a binge',
    ],
  },
];

export const NONVEG_WEEK_DAYS = [
  {
    title: 'Day 1 — Tandoori chicken bowl',
    meals: [
      'Breakfast: 3 egg masala scramble + 2 multigrain toasts + orange',
      'Snack: Greek yogurt + berries',
      'Lunch: Tandoori chicken (150 g) + 1 cup rice + cucumber-onion salad + small dal',
      'Afternoon snack: Banana + dates',
      'Dinner: Palak dal + 2 phulkas + roasted broccoli',
      'Evening (optional): Chocolate milk or whey shake',
    ],
  },
  {
    title: 'Day 2 — Fish curry light',
    meals: [
      'Breakfast: Oatmeal with banana, walnuts, and milk + 1 boiled egg',
      'Snack: Apple + string cheese',
      'Lunch: Fish curry (tilapia or salmon, light coconut milk) + brown rice + kachumber',
      'Afternoon snack: Peanut butter whole-grain sandwich (thin layer)',
      'Dinner: Chicken stir-fry (breast, peppers, soy-ginger) + quinoa',
      'Evening: Warm turmeric milk (optional)',
    ],
  },
  {
    title: 'Day 3 — Balanced plate day',
    meals: [
      'Breakfast: Vegetable upma + side of 2 boiled eggs',
      'Snack: Trail mix (unsalted)',
      'Lunch: Chicken biryani (moderate oil, extra salad) + raita',
      'Afternoon snack: Banana + water',
      'Dinner: Moong dal khichdi + grilled fish tikka (120 g)',
      'Evening: Rice + yogurt or lassi',
    ],
  },
  {
    title: 'Day 4 — North Indian plate',
    meals: [
      'Breakfast: Paneer and egg bhurji mix (2 eggs + 50 g paneer) + 1 paratha',
      'Snack: Carrots + hummus',
      'Lunch: Rajma + jeera rice + grilled chicken salad (100 g chicken on greens)',
      'Afternoon snack: Rice cakes + almond butter',
      'Dinner: Dal tadka + 2 rotis + sautéed green beans',
      'Evening: Whey + fruit',
    ],
  },
  {
    title: 'Day 5 — Lean rotisserie day',
    meals: [
      'Breakfast: Avocado toast + 2 poached eggs + tomatoes',
      'Snack: Cottage cheese + pineapple',
      'Lunch: Rotisserie chicken (skin removed, 150 g) + quinoa + mixed veg',
      'Afternoon snack: Smoothie—milk, banana, spinach, optional whey',
      'Dinner: Chana masala + 2 rotis + side salad',
      'Evening: Handful of almonds',
    ],
  },
  {
    title: 'Day 6 — South Indian + protein',
    meals: [
      'Breakfast: Idli (3) + sambar + 2 boiled eggs',
      'Snack: Edamame or roasted chana',
      'Lunch: Lemon rice + fish (air-fried or shallow pan, 120 g) + cabbage poriyal',
      'Snack: Popcorn + fruit',
      'Dinner: Chicken keema (lean, minimal oil) + salad + small rice portion',
      'Evening: Buttermilk',
    ],
  },
  {
    title: 'Day 7 — Reset and prep',
    meals: [
      'Breakfast: Protein smoothie (milk, peanut butter, banana, cocoa)',
      'Snack: Hard-boiled eggs (2) + fruit',
      'Lunch: Buddha bowl—brown rice, chickpeas, grilled chicken, tahini-lemon dressing',
      'Afternoon snack: Dates + walnuts',
      'Dinner: Mix veg curry + dal from batch prep + 2 rotis',
      'Treat (optional): One small planned dessert portion',
    ],
  },
];

export function activeDayEatingTable(isVegetarian) {
  const lunchExample = isVegetarian
    ? 'Dal, roti or rice, sabzi, salad'
    : 'Dal, roti or rice, lean chicken or fish, salad';
  return {
    type: 'table',
    title: 'Busy or active days — simple timing',
    intro:
      'Use this on long workdays, gym days, or weekends when you are on your feet—keep familiar foods and steady portions.',
    headers: ['Timing', 'What to eat', 'Notes'],
    rows: [
      ['Morning', 'Protein + whole grain + fruit', 'Same breakfast rhythm all week when possible'],
      ['Midday', lunchExample, 'Largest balanced meal for many people'],
      ['Afternoon', 'Fruit, yogurt, or nuts', 'Light; skip heavy fried snacks'],
      ['Dinner', 'Vegetables + protein + moderate starch', 'Finish eating 2–3 hours before bed if you can'],
      ['Hydration', 'Water through the day', 'Extra fluids in hot Ohio summers'],
    ],
  };
}

/** Build legacy soccer-diet slug redirects → current healthy-diet slugs */
export function buildSoccerDietSlugAliases(resolveDietSlug) {
  const aliases = {
    'vegetarian-soccer-diet-week-ohio': resolveDietSlug('vegetarian', 'men', '35-49'),
    'non-vegetarian-soccer-diet-week-ohio': resolveDietSlug('non-vegetarian', 'men', '35-49'),
  };
  const genders = ['women', 'men'];
  const ages = ['18-34', '35-49', '50-plus'];
  const types = ['vegetarian', 'non-vegetarian'];
  types.forEach((dietType) => {
    const oldPrefix = dietType === 'vegetarian' ? 'vegetarian-soccer-diet' : 'non-vegetarian-soccer-diet';
    genders.forEach((gender) => {
      ages.forEach((age) => {
        aliases[`${oldPrefix}-${gender}-${age}-ohio-indian`] = resolveDietSlug(dietType, gender, age);
      });
    });
  });
  return aliases;
}